

export default requireName;
import EsperantoError from 'utils/EsperantoError';
function requireName(options) {
	if (!options.name) {
		throw new EsperantoError('You must supply a `name` option for UMD modules', {
			code: 'MISSING_NAME'
		});
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/umd/requireName.js.01-babel.map